module.exports = "/packs/media/images/icons/together-ce449ef2f4918a9c3353ac4ecf0171ee.png";